// Imports
import { DateTime } from 'luxon';


/** Formats a date as the value format expected by a `datetime-local` input */
export default function formatForDatetimeLocalInput(date: Date | string) {
	// Normalize to a Luxon date/time
	const dateTime = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date);
	
	
	// Return
	return dateTime.toFormat("yyyy-MM-dd'T'HH:mm");
}
